import React, { Component } from "react";
import { Redirect } from "react-router";
import { connect } from "react-redux";
import { FaUserCircle } from "react-icons/fa";
import Popover from "../../components/uielements/popover";
import IntlMessages from "../../components/utility/intlMessages";
import "./customTopbar.css";
import authAction from "../../redux/auth/actions";

import appAction from "../../redux/app/actions";
import TopbarDropdownWrapper from "./topbarDropdown.style";
import { Link } from "react-router-dom";


const { logout, logoutPopup } = authAction;
const { closeAll } = appAction;
class TopbarUser extends Component {
  constructor(props) {
    super(props);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.hide = this.hide.bind(this);
    this.state = {
      visible: false,
      redirectToProfile: false,
      logoutConfirmVisible: false
    };
  }

  hide() {
    this.setState({ visible: false });
  }
  handleVisibleChange(v) {
    if (!this.state.logoutConfirmVisible) {
      this.setState({ visible: v });
    }
  }

  updateUserDetails = () => {
    this.setState({
      redirectToProfile: true
    });
  };

  render() {
    if (this.state.redirectToProfile) {
      return <Redirect to={"/dashboard/Profile"} />;
    }
    const profileData =
      (this.props.Auth && this.props.Auth.profileData) || {};
    const credData =
      (this.props.Auth &&
        this.props.Auth.credentials &&
        this.props.Auth.credentials.data) ||
      {};
    const credUser = (credData.data && credData.data.user) || {};

    const email = profileData.emailId || credUser.emailId || "";

    const firstName =
      profileData.userFirstName ||
      credUser.userFirstName ||
      profileData.firstName ||
      credUser.firstName ||
      "";
    const lastName =
      profileData.userLastName ||
      credUser.userLastName ||
      profileData.lastName ||
      credUser.lastName ||
      "";

    const nameFromEmail = (e) => {
      if (!e) return "";
      const local = e.split("@")[0];
      return local
        .split(/[._]/)
        .filter(Boolean)
        .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
        .join(" ");
    };

    const fullName =
      [firstName, lastName].filter(Boolean).join(" ").trim() ||
      nameFromEmail(email);

    const avatarLetter = fullName
      ? fullName[0].toUpperCase()
      : email
      ? email[0].toUpperCase()
      : "U";

    const popoverContent = this.state.logoutConfirmVisible ? (
      <div className="tbu-logout-confirm">
        <div className="tbu-logout-confirm-top">
          <div className="tbu-logout-confirm-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
          </div>
          <div className="tbu-logout-confirm-text">
            <span className="tbu-logout-confirm-title">Confirm Logout</span>
            <span className="tbu-logout-confirm-sub">Are you sure you want to log out?</span>
          </div>
        </div>
        <div className="tbu-logout-confirm-actions">
          <button
            className="tbu-confirm-cancel"
            onClick={() => this.setState({ logoutConfirmVisible: false })}
          >
            Cancel
          </button>
          <button
            className="tbu-confirm-ok"
            onClick={() => {
              this.setState({ logoutConfirmVisible: false, visible: false });
              this.props.logoutPopup();
              this.props.closeAll();
            }}
          >
            Logout
          </button>
        </div>
      </div>
    ) : (
      <TopbarDropdownWrapper className="isoUserDropdown">
        <div className="tbu-header">
          <div className="tbu-avatar">{avatarLetter}</div>
          <div className="tbu-info">
            <span className="tbu-welcome">Welcome</span>
            {fullName && (
              <span className="tbu-name" title={fullName}>{fullName}</span>
            )}
            <span className="tbu-email" title={email}>{email}</span>
          </div>
        </div>
        <div className="tbu-divider" />
        <Link
          className="tbu-logout-btn"
          onClick={(e) => {
            e.preventDefault();
            this.setState({ logoutConfirmVisible: true });
          }}
          to=""
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
          Logout
        </Link>
      </TopbarDropdownWrapper>
    );

    return (
      <>
        <Popover
          content={popoverContent}
          trigger="hover"
          visible={this.state.visible}
          onVisibleChange={this.handleVisibleChange}
          arrowPointAtCenter={true}
          placement="bottomLeft"
        >
          <FaUserCircle
            className="logoutIconStyle"
          />
        </Popover>
        {console.log("hh",this.props.Auth.profileData.emailId)}
      </>
    );
  }
}
export default connect(
  state => ({
    Auth: state.Auth
  }),
  { logout,logoutPopup, closeAll }
)(TopbarUser);
